<template>
  <div class="position-relative" v-click-outside="closeWithOutsideClick">
    <div v-if="hasEventCapturing" @click.stop="handleToggleContentMenu">
      <slot name="click-area"></slot>
    </div>
    <div v-else @click.stop="handleToggleContentMenu">
      <slot name="click-area"></slot>
    </div>
    <slide-y-up-transition>
      <div
        v-if="isContentMenu"
        :class="`mobile-none tablet-none z-index-2 position-absolute background-surface border--solid border--complementary-50 border-radius-8 padding-16 width-${modalWidth} ${modalClass}`"
      >
        <slot name="content"></slot>
      </div>
    </slide-y-up-transition>
    <MobilePopup :show="isContentMenu" @setShow="handleCloseContentMenu">
      <template>
        <slot name="content"></slot>
      </template>
    </MobilePopup>
  </div>
</template>

<script>
import { checkScreenDevice } from "@/shared/utils";
import MobilePopup from "./MobilePopup.vue";
import { provide, ref, toRefs } from "vue";
export default {
  components: { MobilePopup },
  props: {
    modalWidth: {
      type: [Number, String],
      default: 585,
    },
    modalClass: {
      type: String,
      default: "left-0 top-41",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasEventCapturing: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    // generate props data
    const { modalWidth, disabled } = toRefs(props);

    const isContentMenu = ref(false);
    const handleToggleContentMenu = () => {
      if (disabled.value) return;
      isContentMenu.value = !isContentMenu.value;
    };
    const handleCloseContentMenu = () => {
      isContentMenu.value = false;
    };

    const closeWithOutsideClick = () => {
      if (!checkScreenDevice(["desktop"])) return;
      isContentMenu.value = false;
    };

    provide("handleCloseDropdownModal", handleCloseContentMenu);

    // return data to be used in template
    return {
      modalWidth,
      isContentMenu,
      handleToggleContentMenu,
      handleCloseContentMenu,
      closeWithOutsideClick,
    };
  },
};
</script>
